import React, { FunctionComponent } from 'react';
import { observer } from 'mobx-react';

import { useStores } from 'Hooks';
import AnonymousRoutes from './anonymous';
import AuthenticatedRoutes from './authenticated';
import { useLocation } from 'react-router-dom';
import * as Constants from 'Models/Constants';

const Routes: FunctionComponent = observer(() => {
    const { authenticationStore } = useStores();
    const location = useLocation();
    const search = new URLSearchParams(location.search);
    const encodedReturnUrl = search.get(Constants.RETURN_URL);
    let returnUrl = '';
    if (encodedReturnUrl) {
        returnUrl = decodeURIComponent(encodedReturnUrl);
    }

    if (authenticationStore.loggedIn) {
        return <AuthenticatedRoutes returnUrl={returnUrl} />;
    } else {
        return <AnonymousRoutes />;
    }
});

export default Routes;
